<template>
    <van-popup
            v-if="selectBrandPopupShow" v-model="selectBrandPopupShow" :close-on-click-overlay="false" @click-overlay="handleClickClose"
            :style="{ height: '450px', background: '#fff' }"overlay-class="custom_popup"position="bottom" round>

        <div class="select_stock_wrap" >
            <div class="select_stock_search">
                <van-search v-model="keyword" @input="getBrandList" placeholder="请输入品牌名称" />
            </div>
            <div class="select_stock_content">
                <van-picker :loading="loading"  :columns="BrandList" :default-index="defaultIndex" :visible-item-count="7"  ref="popupPicker" swipe-duration="100"  title=""   value-key="name"  />
            </div>
            <div class="select_stock_footer">
                <van-button round block type="info" @click="handleClickConfirm">确定</van-button>
            </div>
        </div>
    </van-popup>

</template>

<script>
import { cloudBrandList } from "@/api";
export default {
    name: "select_brand",
    props: {
        selectBrandPopupShow: {
            type: Boolean,
            default: false,
        },
        selectedBrandId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            loading: false,
            keyword:'',
            BrandList:[],
            allWarehouseList:[],
            defaultIndex:0
        };
    },
    created() {
        console.log(this.selectedBrandId);
        this.getBrandList()
    },
    methods: {
        // 获取仓库列表
        getBrandList(){
            this.loading = true
            cloudBrandList({name:this.keyword,pageSize:10,page:1}).then(res => {
                if (res.code === 200) {
                    this.BrandList = res.data.list
                    this.defaultIndex = this.BrandList.findIndex(item => item.id == this.selectedBrandId)
                    this.loading = false
                }
            })
        },
        handleClickClose(){
            this.$emit("update:selectBrandPopupShow", false)
        },

        handleClickConfirm(){
            let value = this.$refs.popupPicker.getValues()[0]

            if(value){
                this.$emit("success", value)
                this.$emit("update:selectBrandPopupShow", false)
            }else{
                this.$toast("请选择品牌")
            }


        },
    },
}
</script>

<style  lang="scss" scoped>
.custom_popup {
    background-color: rgba(0, 0, 0, 0.3);
}
.select_stock_wrap{
    display: flex;
    flex-direction: column;
    height: 100%;
    .select_stock_search{
        padding: 2px 4px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    }
    .select_stock_content{
        flex: 1;
    }
    .select_stock_footer {
        padding:16px;
        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}

</style>